export default __webpack_public_path__ + "static/media/deng.b16b4027.ogg";